import * as tslib_1 from "tslib";
import { ElementRef, OnInit, Renderer2 } from '@angular/core';
import { Subject } from 'rxjs';
import { IsInvalidDirective } from 'src/app/modules/core/directives/is-invalid.directive';
export class ModalAddTreeSpeciesComponent {
    constructor(_renderer2, _bsModalService, el, plantingSiteService, treeSpeciesService) {
        this._renderer2 = _renderer2;
        this._bsModalService = _bsModalService;
        this.el = el;
        this.plantingSiteService = plantingSiteService;
        this.treeSpeciesService = treeSpeciesService;
        this._onDestroy$ = new Subject();
        this.position = 1;
        this.isInvildSelect = false;
        this.treeSpecies = {};
        this.listSpecies = [];
        this.createNewSpecies = (name) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.creatingNew = true;
            let species = yield this.plantingSiteService.createSpeies(name);
            this.speciesDto.push(species);
            this.creatingNew = false;
            return { id: species.id, species: species.species };
        });
        this.creatingNew = false;
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.isSaved$ = new Subject();
            var isEmpty = Object.keys(this.treeSpecies).length;
            if (isEmpty != 0) {
                this.speciesData = {
                    species: this.treeSpecies.species,
                    description: this.treeSpecies.description,
                    id: this.treeSpecies.id,
                };
                this.listSpecies.push(this.speciesData);
                const speciesData = yield this.plantingSiteService.getSpeciesById(this.treeSpecies.id);
                this.description = speciesData.description;
                this.photoUrl = speciesData.photoUrl;
            }
        });
    }
    save() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.isInvalidDirectives.some(value => value.isInvalid))
                return;
            if (this.isEditSpecies) {
                const result = yield this.treeSpeciesService.updateSpeies(this.treeSpecies);
                this.treeSpecies.speciesId = result.id;
            }
            else {
                const result = yield this.treeSpeciesService.createSpeies(this.treeSpecies);
                this.treeSpecies.speciesId = result.id;
            }
            if (this.newPhoto) {
                var resultPhoto = yield this.plantingSiteService.updatePlantedTreesPhoto(this.newPhoto, this.treeSpecies.speciesId);
                this.treeSpecies.photoUrl = resultPhoto.data.originalUrl;
            }
            this.isSaved$.next(true);
            this._bsModalService.hide();
        });
    }
    hideNavModal() {
        this._bsModalService.hide();
    }
    ngOnDestroy() {
        this._onDestroy$.next();
        this._onDestroy$.complete();
        this.isSaved$.complete();
        const body = document.getElementsByTagName("body")[0];
        this._renderer2.removeClass(body, "modal-open");
    }
    onPhotoSelected(photo) {
        this.newPhoto = photo;
    }
    onSelect(species) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (species.length != 0) {
                const speciesData = yield this.plantingSiteService.getSpeciesById(species[0].id);
                this.isInvildSelect = false;
                const ngSelect = document.getElementsByClassName("ng-select-container")[0];
                ngSelect.setAttribute('style', '');
                this.photoUrl = speciesData.photoUrl;
                this.description = speciesData.description;
                this.treeSpecies.species = speciesData.species;
            }
            else {
                this.photoUrl = null;
                this.description = "";
                if (this.newPhoto) {
                    this.newPhoto = null;
                }
            }
        });
    }
    trimAndLower(term, species) {
        let pattern = '^' + term.trim().toLowerCase() + '$';
        let matchingRegex = new RegExp(pattern);
        return !!species.species.toLowerCase().match(matchingRegex);
    }
}
